// extracted by mini-css-extract-plugin
export default {"cta":"gG-z","disabled":"hG-z"};